import {cashoutEventBus, CashoutEvents, CheckoutErrorMode} from "./bus";
import axios from "axios";
import {CashoutData, PurchaseInstruction, PurchaseInstructionResponse} from "./models";

function postPurchaseInstruction(purchaseInstruction: PurchaseInstruction,
                                 successCallback: (response: PurchaseInstructionResponse) => void,
                                 failureCallback: (response: PurchaseInstructionResponse | null, errorMode: CheckoutErrorMode | null) => void): void {
    axios.post('/jsonapi/crypto-purchase', purchaseInstruction)
        .then(response => {
            let purchaseInstructionResponse = response.data as PurchaseInstructionResponse;
            if (purchaseInstructionResponse.wasSuccessful) {
                console.info('Purchase was a success');
                successCallback(purchaseInstructionResponse);
            } else {
                console.warn('Purchase was a failure');
                failureCallback(purchaseInstructionResponse, purchaseInstructionResponse.errorMode);
            }
        })
        .catch(error => {
            console.error(`Failed to post purchase instruction: ${error}`);
            failureCallback(null, null)
        })
}

export function doOrder(cashoutData: CashoutData) {
    cashoutEventBus.$emit(CashoutEvents.CHECKOUT_START);
    postPurchaseInstruction(cashoutData.purchaseInstruction,
        response => {
            window.location.href = `/cashout/complete?ref=${response.reference}`
        }, (response, errorMode) => {
            if (response)
                cashoutEventBus.$emit(CashoutEvents.CHECKOUT_ERROR, errorMode, response.message);
            else
                cashoutEventBus.$emit(CashoutEvents.CHECKOUT_FAILURE);
        })
}
